"use client";

import Link from "next/link";
import { useEffect } from "react";
import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconCookie from "@/app/(components)/generics/Icons/IconCookie";
import { ConsentStore } from "@/app/stores/ConsentStore";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { LegalPaths } from "@/app/vars/Routes";
import styles from "./ConsentBanner.module.css";

type Props = {
  lang: string;
};

export default function ConsentBanner(props: Props) {
  const T = useT();
  const { lang } = props;
  const isBannerOpen = ConsentStore((state) => state.isBannerOpen);
  const isSettingsOpen = ConsentStore((state) => state.isSettingsOpen);
  const onInit = ConsentStore((state) => state.onInit);
  const accept = ConsentStore((state) => state.accept);
  const refuse = ConsentStore((state) => state.refuse);

  useEffect(() => {
    onInit();
  }, [onInit]);

  if (!isBannerOpen || isSettingsOpen) {
    return null;
  }

  return (
    <section className={styles.container} aria-label={T(TKey.CONSENT_BANNER_TITLE)}>
      <div className={styles.header}>
        <span className={styles.icon}>
          <IconCookie size={18} />
        </span>
        <h2 className={styles.title}>{T(TKey.CONSENT_BANNER_TITLE)}</h2>
      </div>

      <p className={styles.text}>
        {T(TKey.CONSENT_BANNER_TEXT)}{" "}
        <Link className={styles.link} href={`/${lang}${LegalPaths.PRIVACY}`}>
          {T(TKey.CONSENT_BANNER_LINK)}
        </Link>
        .
      </p>

      <div className={styles.actions}>
        <Button
          isLink={false}
          type={ButtonType.PRIMARY}
          small={true}
          className={styles.actionButton}
          full={true}
          text={T(TKey.CONSENT_ACCEPT)}
          onClick={accept}
        />
        <Button
          isLink={false}
          type={ButtonType.OUTLINE}
          small={true}
          className={styles.actionButton}
          full={true}
          text={T(TKey.CONSENT_REFUSE)}
          onClick={refuse}
        />
        <Button
          isLink={false}
          type={ButtonType.LINK}
          small={true}
          className={styles.settingsLink}
          text={T(TKey.CONSENT_SETTINGS)}
          onClick={() => ModalStore.getState().openConsentSettings(lang)}
        />
      </div>
    </section>
  );
}
